import { EffectFade } from 'swiper';

import { Slider } from './slider';

class MonthlySlider extends Slider {
  init() {
    super.init();
  }
}
function changeTabindex() {
  const wraps = document.querySelectorAll('.js-slider-monthly');
  wraps.forEach((wrap) => {
    const container = wrap.querySelector<HTMLDivElement>('.js-slider-monthly-container');
    const slides = container?.querySelectorAll('.swiper-slide');
    slides?.forEach((slide) => {
      const slideLink = slide.querySelector('a');
      if (!slideLink) return;
      if (slide.classList.contains('swiper-slide-active')) {
        slideLink.setAttribute('aria-hidden', 'false');
        slideLink.setAttribute('tabindex', '0');
      } else {
        slideLink.setAttribute('aria-hidden', 'true');
        slideLink.setAttribute('tabindex', '-1');
      }
    });
  });
}
export const monthlySlider = () => {
  const wraps = document.querySelectorAll('.js-slider-monthly');
  wraps.forEach((wrap) => {
    const container = wrap.querySelector<HTMLDivElement>('.js-slider-monthly-container');
    const thumbs = wrap.querySelector<HTMLDivElement>('.js-slider-monthly-thumbs');
    if (!container || !thumbs) return;

    const parameters = {
      modules: [EffectFade],
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 300,
      allowTouchMove: false,
      on: {
        init: () => {
          changeTabindex();
        },
        slideChange: () => {
          changeTabindex();
        },
      },
    };

    const monthlySliderInstance = new MonthlySlider(container, parameters);

    monthlySliderInstance.init();

    const thumbsSlides = thumbs.querySelectorAll('.swiper-slide');
    thumbsSlides.forEach((thumbsSlide, index) => {
      thumbsSlide.addEventListener('click', (e) => {
        const switchCurrentIndex = () => {
          const currentSlide = Array.from(thumbsSlides).find((slide) =>
            slide.classList.contains('swiper-slide-thumb-active'),
          );
          currentSlide?.classList.remove('swiper-slide-thumb-active');
          (e.currentTarget as HTMLButtonElement)?.classList.add('swiper-slide-thumb-active');
        };

        monthlySliderInstance.instance?.slideTo(index);
        switchCurrentIndex();
      });
    });
  });
};
